import type { CollectorSelfProfileOptions } from './collectorSelfProfileOptions';
import { client } from '../client';
import { UserProfile, UserRoleName } from './types/UserProfile';

type UpdateClientTagPayload = {
  client_ids: number[];
  /** Omit to leave division assignments untouched; send [] to clear them all. */
  client_division_ids?: number[];
};

export const updateUserClientTag = async (
  userId: number,
  payload: UpdateClientTagPayload,
  userRole?: UserRoleName,
  options?: CollectorSelfProfileOptions,
): Promise<UserProfile> => {
  const rolePrefixes: Partial<Record<UserRoleName, string>> = {
    [UserRoleName.CareAdvisor]: '/care_advisor',
    [UserRoleName.Collector]: '/collector',
    [UserRoleName.Admin]: '/admin',
    [UserRoleName.SuperAdmin]: '/superadmin',
  };

  const prefix = (userRole && rolePrefixes[userRole]) || '/admin';
  const isCollectorEditingSelf = userRole === UserRoleName.Collector && options?.collectorEditingSelf === true;

  const url = isCollectorEditingSelf ? '/collector/me/clients' : `${prefix}/users/${userId}/clients`;

  const { data } = await client.patch<UserProfile>(url, payload);

  return data;
};
